import * as THREE from 'three'
import Experience from '../Experience.js'
import Environment from './Environment.js'
import Candle from './Candle.js'
import Flame from './Flame.js'
import Smoke from './Smoke.js'
import BackgroundParticles from './BackgroundParticles.js'

/**
 * World
 * Populates the scene once resources are ready.
 * Order: Environment → Candle → Flame → Flame2 → BackgroundParticles
 *
 * Two flames for two wicks: flame at (-0.5, -0.20, 0), flame2 at (0.5, -0.20, 0).
 * Both receive flicker from flameLight each frame.
 */
export default class World {
    constructor() {
        this.experience = new Experience()
        this.scene      = this.experience.scene
        this.resources  = this.experience.resources

        this.resources.on('ready', () => {
            this.environment         = new Environment()
            this.candle              = new Candle()
            this.flame               = new Flame(new THREE.Vector3(-0.7, -0.20, 0))
            this.flame2              = new Flame(new THREE.Vector3( 0.6, -0.20, 0))
            this.smoke               = new Smoke(new THREE.Vector3(-0.7, -0.20, 0))
            this.smoke2              = new Smoke(new THREE.Vector3( 0.6, -0.20, 0))
            this.backgroundParticles = new BackgroundParticles()
        })
    }

    update() {
        if (!this.environment) return

        this.environment.update()
        this.candle.update()
        this.flame.update()
        this.flame2.update()
        this.smoke.update()
        this.smoke2.update()

        // Sync both flames with PointLight intensity (normalised 0-1)
        const flicker = this.environment.flameLight.intensity / 2.5
        this.flame.setFlicker(flicker)
        this.flame2.setFlicker(flicker * 0.95) // Трохи інша амплітуда для другого

        this.backgroundParticles.update()
    }
}
